import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import WhatWeDo from "../components/WhatWeDo";
import OurApproach from "../components/OurApproach";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="bg-page min-h-screen">
      <Navbar />
      <Hero />
      <WhatWeDo />
      <OurApproach />
      <Footer />
    </div>
  );
}
